const Builders = () => {
    return (
        <svg width="300" height="280" fill="none" viewBox="0 0 300 200" xmlns="http://www.w3.org/2000/svg">
            <path fill="#fff" d="M0 0H300V200H0z"/>
            <path
                fill="#F2F5F7"
                fillRule="evenodd"
                d="M155 196h112.754V41H155v155z"
                clipRule="evenodd"
            />
            <path
                fill="#5C5CE6"
                fillRule="evenodd"
                d="M192.607 56.5h-24.363a2.19 2.19 0 01-2.189-2.192v-.044c0-1.21.98-2.193 2.189-2.193h24.363a2.19 2.19 0 012.188 2.193v.044a2.19 2.19 0 01-2.188 2.192z"
                clipRule="evenodd"
            />
            <path
                stroke="#CED8E1"
                strokeWidth="0.8"
                d="M166.055 107.429H256.7M166.055 122.929H256.7"
            />
            <mask
                id="mask0"
                width="113"
                height="155"
                x="155"
                y="41"
                maskUnits="userSpaceOnUse"
            >
                <path fill="#fff" d="M155 196h112.754V41H155v155z"/>
            </mask>
            <g fillRule="evenodd" clipRule="evenodd" mask="url(#mask0)">
                <path
                    fill="#51DAAF"
                    d="M245.646 114.071H256.7v-2.214h-11.054v2.214z"
                />
                <path
                    fill="#90DCF5"
                    d="M166.054 114.071h11.055v-2.214h-11.055v2.214z"
                />
                <path
                    fill="#CED8E1"
                    d="M245.646 151.024H256.7v-2.214h-11.054v2.214z"
                />
                <path
                    fill="#51DAAF"
                    d="M250.067 129.571h6.633v-2.214h-6.633v2.214z"
                />
                <path
                    fill="#90DCF5"
                    d="M166.054 129.571h8.844v-2.214h-8.844v2.214zM166.054 101.893h8.844v-2.214h-8.844v2.214z"
                />
                <path
                    fill="#51DAAF"
                    d="M247.857 101.893h8.843v-2.214h-8.843v2.214z"
                />
                <path
                    fill="#CED8E1"
                    d="M247.857 155.453h8.843v-2.215h-8.843v2.215z"
                />
            </g>
            <path
                fill="#CED8E1"
                fillRule="evenodd"
                d="M0 200h300v-3.55H0V200z"
                clipRule="evenodd"
            />
            <path
                fill="#FF6469"
                fillRule="evenodd"
                d="M178.819 175.148l-5.33 18.639h13.325l-5.33-18.639h-2.665z"
                clipRule="evenodd"
            />
            <path
                fill="#EC6C00"
                fillRule="evenodd"
                d="M173.489 193.787l-2.665 2.663h18.655l-2.665-2.663h-13.325zM178.819 175.148l-5.33 18.639h13.325l-5.33-18.639h-2.665z"
                clipRule="evenodd"
            />
            <mask
                id="mask1"
                width="14"
                height="19"
                x="173"
                y="175"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#fff"
                    d="M178.819 175.148l-5.33 18.639h13.325l-5.33-18.639"
                />
            </mask>
            <g mask="url(#mask1)">
                <path
                stroke="#CED8E1"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2.319"
                d="M176.154 180.806h9.328"
                />
            </g>
            <mask
                id="mask2"
                width="14"
                height="19"
                x="173"
                y="175"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#fff"
                    d="M178.819 175.148l-5.33 18.639h13.325l-5.33-18.639"
                />
            </mask>
            <g mask="url(#mask2)">
                <path
                stroke="#CED8E1"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2.319"
                d="M170.824 189.355h17.322"
                />
            </g>
            <path
                stroke="#CED8E1"
                strokeWidth="1.586"
                d="M32.37 66.793l67.622 56.305 67.622-56.305"
            />
            <path
                stroke="#CED8E1"
                strokeWidth="1.586"
                d="M32.37 123.098l67.622-56.305 67.622 56.305M32.37 123.098h135.244M32.37 66.793h135.244"
            />
            <path
                stroke="#CED8E1"
                strokeWidth="1.586"
                d="M32.37 123.098l67.622 56.304 67.622-56.304M32.37 66.793v56.305"
            />
            <path
                stroke="#CED8E1"
                strokeWidth="1.586"
                d="M32.37 179.402l67.622-56.304 67.622 56.304M32.37 123.098v73.195M32.557 54.75v12.043M99.992 66.793v56.305M99.992 123.098v73.195M100.179 54.75v12.043M167.614 66.793v56.305M167.614 123.098v73.195M167.801 54.75v12.043M32.37 179.402h135.244"
            />
            <path
                fill="#FA8100"
                d="M97.287 137.509l-4.781 1.37 1.37 4.778 4.783-1.37-1.372-4.778zm-19.333-3.807l-4.772 1.403 1.404 4.768 4.773-1.402-1.405-4.769zm32.916-12.163l-4.841 1.142 1.143 4.837 4.841-1.142-1.143-4.837z"
            />
            <path
                fill="#FA8100"
                d="M91.466 127.135a4.976 4.976 0 015.617 2.187l2.966 3.682-1.573.856a4.976 4.976 0 01-3.379 5.156l-.206.063a4.972 4.972 0 01-6.152-3.406l-.685-2.389a4.972 4.972 0 013.412-6.149z"
            />
            <path
                fill="#0C6E8E"
                d="M97.506 133.159a2.487 2.487 0 013.076 1.703l-4.782 1.371a2.486 2.486 0 011.706-3.074zm-7.348-3.064c1.981-.568 3.893.041 4.272 1.361.137.478.053.985-.203 1.463a1.398 1.398 0 00-2.118 1.753 5.67 5.67 0 01-.58.201c-1.097.314-2.172.268-2.978-.06l-.067-.03-.43-1.499a4.967 4.967 0 01-.19-1.571l.017-.257.04-.045c.526-.57 1.307-1.049 2.237-1.316z"
            />
            <path
                stroke="#0C6E8E"
                strokeLinejoin="round"
                strokeWidth="6.3"
                d="M103.577 144.979c10.303-1.335 5.999-18.473 5.999-18.473M88.138 147.111c-18.071 4.999-9.508-4.392-11.362-9.262"
            />
            <path
                fill="#EC6C00"
                fillRule="evenodd"
                d="M96.768 152.104l-1.844 26.585h-10.29l2.25-28.579 9.884 1.994z"
                clipRule="evenodd"
            />
            <path
                fill="#EC6C00"
                fillRule="evenodd"
                d="M104.775 152.321l7.271 26.368h-10.047l-7.089-25.073 9.865-1.295z"
                clipRule="evenodd"
            />
            <path
                fill="#EC6C00"
                fillRule="evenodd"
                d="M104.775 152.322l-17.243 2.412-1.724-12.305 17.242-2.413 1.725 12.306z"
                clipRule="evenodd"
            />
            <path
                fill="#F8A900"
                fillRule="evenodd"
                d="M110.172 171.896h-10.093l-.703-2.485h10.111l.685 2.485zM95.393 171.896H85.168l.196-2.485h10.203l-.174 2.485zM104.127 147.698l-17.243 2.412-.345-2.461 17.243-2.412.345 2.461zM86.51 131.948c-.152-1.887-.124-5.517 6.033-7.556l.38 1.146a5.968 5.968 0 014.57 2.772l2.342.723-1.725.572-5.66 1.875-5.66 1.875-1.726.571 1.445-1.978z"
                clipRule="evenodd"
            />
            <path
                fill="#371F38"
                fillRule="evenodd"
                d="M101.297 176.204l.702 2.485h11.849l-2.488-2.485h-10.063zM84.83 176.204l-.197 2.485h12.95l-2.487-2.485H84.829z"
                clipRule="evenodd"
            />
            <path
                fill="#6D2C00"
                d="M160.449 61.194v4.97h4.975v-4.97h-4.975zm-.235-20.924l-3.518 3.515 3.518 3.514 3.518-3.514-3.518-3.515z"
            />
            <path
                stroke="#0C6E8E"
                strokeLinejoin="round"
                strokeWidth="6.3"
                d="M158.544 41.938c-4.857-4.852-12.731-4.852-17.588 0l-5.276 5.273"
            />
            <path
                fill="#6D2C00"
                d="M151.614 46.218a4.976 4.976 0 01.811 5.974l-1.784 4.379-1.51-.96a4.975 4.975 0 01-6.148-.457l-.156-.15a4.973 4.973 0 01-.003-7.031l1.758-1.758a4.972 4.972 0 017.032.003z"
            />
            <path
                fill="#371F38"
                d="M153.166 41.79c.001 1.533-1.234 2.85-2.999 3.422a4.943 4.943 0 011.447 1.006l.149.156a4.973 4.973 0 011.161 4.57 4.97 4.97 0 01-4.571-1.16l-.156-.149a1.382 1.382 0 00-2.317 1.31 4.975 4.975 0 01-4.288-.93c.21-.683.57-1.326 1.079-1.882l.153-.16 1.758-1.758a4.953 4.953 0 011.529-1.043c-1.706-.59-2.89-1.886-2.89-3.387-.001-2.06 2.225-3.728 4.971-3.727 2.746 0 4.973 1.672 4.974 3.731z"
            />
            <path
                fill="#EC6C00"
                fillRule="evenodd"
                d="M142.263 56.224h-19.952v9.94h14.923a5 5 0 005.002-4.97l.027-4.97z"
                clipRule="evenodd"
            />
            <path
                fill="#371F38"
                fillRule="evenodd"
                d="M124.798 66.165v-9.941h-2.487l-4.975 9.94h7.462z"
                clipRule="evenodd"
            />
            <path
                fill="#F8A900"
                fillRule="evenodd"
                d="M129.773 66.17h-2.488v-9.946h2.488v9.946z"
                clipRule="evenodd"
            />
            <path
                fill="#EC6C00"
                fillRule="evenodd"
                d="M124.697 44.274a8.373 8.373 0 000 11.849l8.14 8.134 11.859-11.85-8.141-8.133a8.39 8.39 0 00-11.858 0z"
                clipRule="evenodd"
            />
            <path
                fill="#F8A900"
                fillRule="evenodd"
                d="M136.729 44.447l-5.929 5.925 1.759 1.757 5.929-5.924-1.759-1.758z"
                clipRule="evenodd"
            />
            <path
                fill="#FA8100"
                fillRule="evenodd"
                d="M143.014 58.468l-3.517-3.515 3.517-3.514 3.518 3.514-3.518 3.515z"
                clipRule="evenodd"
            />
            <path
                stroke="#0C6E8E"
                strokeLinejoin="round"
                strokeWidth="6.3"
                d="M138.407 51.392l9.506 9.497a5.288 5.288 0 003.739 1.548h8.84"
            />
            <path
                fill="#F8A900"
                fillRule="evenodd"
                d="M143.759 44.182c1.146-1.507 3.587-4.196 9.538-1.617l-.481 1.107a5.958 5.958 0 011.56 5.109l1.263 2.099-1.667-.723-5.471-2.37-5.471-2.37-1.668-.722 2.397-.513z"
                clipRule="evenodd"
            />
            <path
                fill="#90DCF5"
                fillRule="evenodd"
                d="M69.784 136.63l40.146-15.401-.714-1.859-40.146 15.401.714 1.859z"
                clipRule="evenodd"
            />
            <path
                fill="#FF6469"
                fillRule="evenodd"
                d="M16.553 175.148l-5.33 18.639h13.324l-5.33-18.639h-2.664z"
                clipRule="evenodd"
            />
            <path
                fill="#EC6C00"
                fillRule="evenodd"
                d="M11.223 193.787l-2.665 2.663h18.654l-2.665-2.663H11.223zM16.553 175.148l-5.33 18.639h13.324l-5.33-18.639h-2.664z"
                clipRule="evenodd"
            />
            <mask
                id="mask3"
                width="14"
                height="19"
                x="11"
                y="175"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#fff"
                    d="M16.553 175.148l-5.33 18.639h13.324l-5.33-18.639"
                />
            </mask>
            <g mask="url(#mask3)">
                <path
                stroke="#CED8E1"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2.319"
                d="M13.888 180.806h9.327"
                />
            </g>
            <mask
                id="mask4"
                width="14"
                height="19"
                x="11"
                y="175"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#fff"
                    d="M16.553 175.148l-5.33 18.639h13.324l-5.33-18.639"
                />
            </mask>
            <g mask="url(#mask4)">
                <path
                stroke="#CED8E1"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2.319"
                d="M8.558 189.355H25.88"
                />
            </g>
            <path
                fill="#BB5602"
                d="M237.807 144.796l-4.731 1.538-1.535-4.728 4.73-1.538 1.536 4.728zM250.751 139.613l3.811-3.197-3.196-3.808-3.811 3.197 3.196 3.808z"
            />
            <path
                stroke="#0C6E8E"
                strokeLinejoin="round"
                strokeWidth="6.3"
                d="M235.572 144.229c.599 4.503 1.782 8.449 3.548 11.835 1.767 3.387 4.923 7.726 9.469 13.017 9.476-7.518 14.215-13.438 14.217-17.76.001-4.322-3.55-9.056-10.653-14.201"
            />
            <path
                fill="#BB5602"
                d="M254.637 154.323h-4.975v4.971h4.975v-4.971z"
            />
            <path
                fill="#BB5602"
                d="M255.203 143.764c-1.949-.671-4.107.263-5.301 2.134l-3.015 3.683 1.357.89c-.38 2.281.68 4.486 2.626 5.266l.187.07c2.337.805 4.975-.699 5.891-3.36l.83-2.408c.916-2.661-.237-5.47-2.575-6.275z"
            />
            <path
                fill="#371F38"
                d="M258.38 140.292c-1.286.732-1.938 2.464-1.771 4.313a3.973 3.973 0 00-1.372-.811l-.19-.06c-1.489-.431-3.075.05-4.248 1.151.246 1.591 1.2 2.946 2.638 3.523l.187.07c.65.223.97 1.004.715 1.743-.167.486-.541.833-.963.95.231 1.476 1.073 2.749 2.347 3.382a5.594 5.594 0 001.179-1.856l.08-.219.829-2.409a5.68 5.68 0 00.315-1.864c1.118 1.24 2.636 1.678 3.895.96 1.725-.984 2.309-3.768 1.304-6.218-1.006-2.451-3.22-3.639-4.945-2.655z"
            />
            <path
                fill="#EC6C00"
                fillRule="evenodd"
                d="M262.121 171.39v24.906h-9.949v-24.852l9.949-.054z"
                clipRule="evenodd"
            />
            <path
                fill="#EC6C00"
                fillRule="evenodd"
                d="M252.172 171.39v24.906h-12.437l2.488-2.485v-22.367l9.949-.054z"
                clipRule="evenodd"
            />
            <path
                fill="#371F38"
                fillRule="evenodd"
                d="M242.223 193.811h9.949v2.485h-12.437l2.488-2.485z"
                clipRule="evenodd"
            />
            <path
                fill="#371F38"
                fillRule="evenodd"
                d="M262.121 193.811h-9.949v2.485h12.436l-2.487-2.485z"
                clipRule="evenodd"
            />
            <path
                fill="#EC6C00"
                fillRule="evenodd"
                d="M242.223 171.444h19.898v-12.426h-19.898v12.426z"
                clipRule="evenodd"
            />
            <path
                fill="#F8A900"
                fillRule="evenodd"
                d="M242.223 167.716h19.898v-2.485h-19.898v2.485zM242.223 189.503h19.898v-2.486h-19.898v2.486z"
                clipRule="evenodd"
            />
            <path
                stroke="#371F38"
                strokeWidth="0.933"
                d="M252.172 193.811v-22.367"
            />
            <path
                fill="#CED8E1"
                fillRule="evenodd"
                d="M171.608 167.947l80.385-35.8.399.906-80.385 35.8-.399-.906z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Builders;